module.exports = __webpack_public_path__ + "static/media/galerija_2019 (15).fbfebe2c.jpg";